export default __webpack_public_path__ + "static/media/champa.6b74bf2d.jpg";